import axios from "axios";
import APILinks from "@/links/links";

export default {
  sendErrorToAdmin(message, jsonData) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(
      APILinks.ADMIN_ERROR_NOTIFICAITON(),
      {
        message,
        jsonData,
      },
      { headers: headers }
    );
  },
};
